import { PortableTextComponents } from '@portabletext/react'

export const textBody: PortableTextComponents = {
  block: {
    normal: ({ children }) => (
      <p className="text-16 lg:text-16 text-neutrals-700 mb-5 font-regular last:mb-0 slg:leading-1.5">{children}</p>
    ),
  },
}
